export const lang = current_language;


export const translations = {
    en: {
        welcomeMessage: "Welcome to my website!",
        join: "Join",
        email: "E-mail:",
        //forms
        male: "male",
        female: "female",
        location: "Locations",
        password_toggle: "show password",
        password_toggle_of: "hide password",
        repeat_email: "Repeat e-mail:",
        password: "password:",
        repeat_password: "Repeat password:",
        firstName: "First name:",
        lastName: "Last Name:",
        phone: "phone",
        city: "City:",
        postalCode: "Postal Code:",
        flat: "Flat nr.:",
        sex: "Gender:",
        street: "Street:",
        birthDate: "Birth Date:",
        invoicesToggle: "Do you need an invoice?",
        invoice_postalCode: 'Postal Code:',
        invoice_city: 'City:',
        invoice_name: 'Name:',
        invoice_street: 'Street:',
        invoice_flat: 'Nr domu/lok.:',
        invoice_tax: "Tax Number",
        send: "Send",
        newPassword: "New Password:",
        repeatNewPassword: "Repeat new Password:",


        //main page
        //gallery
        versatile: 'versatile',
        modern: 'modern',
        intimate: 'intimate',
        active: 'active',
        alwaysClose: 'always close',
        more: 'more',

        //form Errors
        email_error: "Wprowadz poprawny adres E-mail",
        equalTo_error: "Wprowadzone pola nie sa takie same",
        required_error: "Pole wymagane",
        postalCodeFormat_error: "Valid  format is 00-000",
        strongPassword: "Password must contain at least 8 characters, including one uppercase letter, one lowercase letter, one digit, and one special character.",
        monday: 'monday',
        tuesday: 'tuesday',
        wednesday: 'wednesday',
        thursday: 'thursday',
        friday: 'friday',
        saturday: 'saturday',
        sunday: 'sunday',
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December',
        provided: "Provided",
        minLength: "min length is 9 digits",
        maxLength: "max length is 9 digits",
        maxAge: "provide age is too big",
        minAge: "you are under 18",
        paymentError: "Payment failed",
        paymentSuccess: "Payment was successful. Remember to install the Active Zone app.",
        //club Page

        subscriptionsMultiSport: "Subscriptions MultiSport",
        subscriptionsMedicover: "Subscriptions Medicover Sport ",
        membershipSmart: "SMART annual membership",
        membershipFlex: "FLEX membership",


        chooseOffer: "Choose an offer just for you!",
        yourChoose: "Your choice",
        localizations: "In what location?",
        peakTitle: "AT WHAT TIME?",
        peak: " No limits",
        offPeak: " From 6.00 am to 3 pm	",
        period: "FOR WHAT TERM?	",
        priceTitle: "Your price is	",
        settlementPeriod: "for a 28-day settlement period",
        settlementPeriodAfter: "*A 28-day settlement period shall apply.",
        settlementPeriodPreSell: "	During the first month*	",
        settlementPeriodPreSellAfter: "	PLN first period 28 days, then PLN 169	",
        getMembershipBtn: "	Continue ",
        periodOfNoticeBefore: "	*with ",
        periodOfNoticeAfter: "-days notice period",
        sendError: "Oops, something went wrong",
        addMembershipSuccess: "Your contract is now Active!",
        clubMap: "Map to the club",
        classPersons: "number of people",
        classSing: "Sign up in the app",
        annualContract: "annual contract",
        IndefiniteContract: "Indefinite",
        hoursInfo: " during the club's opening hours",
        weeks: "weeks",
        infinityStones: "czas nieokreślony",
        subscriptionsFor: "subscriptions for",
        forAppHandler: "for app users",
        inDaClub: "With entry at the selected club during opening hours",
        inAllClubs: "To all clubs",
        withApp: "via the app",
        withcode: "and a QR code",


        //profil
        invoice: "Invoice",
        personalDate: "Address data",
        addressDate: "Personal data",
        editBtn: "Edit data",
        changePassword: "Change password",

        changePasswordSuccess: "The password has been changed",
        agree: "Consents",
        card: "Your card",
        cardBtn: "Change card",
        hey: "Hello",
        yourDate: "Your data",
        logOut: "logout",

        //profil edit

        profileEditTitle: "Data editing",
        saveChanges: "Save Changes",

        registerPageBtn: "Register",

        //login
        loginBtn: "Log in",
        LoginTitle: "You already have an account?",
        passQuestion: "Forgot your password?",
        passBtn: "Reset password",
        registerTitle: "You don't have an account?",
        registerBtn: "Register",
        checkEmail: "Check your email inbox",

        //change pasword
        changePasswordTitle: "Set new passsword",
        oldPassword: "Old password:",
        passwordRules: "The new password should consist of at least 8 characters, including uppercase and lowercase letters, numbers, and special characters.",
        changeBtn: "change password",

        //order
        orderTitle: "This is the final step!",
        orderPreTitle: "You have chosen:",
        orderChangBtn: "Change your preferences	",
        discountCodeBtn: "I have a discount code",
        discountCode: "	Discount code:",
        addCode: "	Add your code",
        buy: "PAY WITH CARD",
        orderBack: "Take back",


        // main page
        //hero


        newClub: "<span class='insideTitle'>Fitness</span><br>near you",
        heroPreTitle: "Opening soon!",
        heroBtn: "PASS FROM ONLY 119 PLN",
        subTitle: "*Available only on presale.",
        gymsTitle: "Your fitness, just behind the corner",
        ourApp: "You can find our app at",


        // main page slide
        colSlide1: "How to become a customer?",
        colSlide2: "How to enter the club?",
        slide2: "Choose a membership – or a subscription if you prefer to use your Multi Sport or Medicover Sport app",
        slide1: "Choose a club in your area",
        slide7: "Generate a QR code in the Active Zone app, or in the partner app if you chose a MultiSport or Medicover Sport subscription",
        slide3: "Register online",
        slide4: "Add your payment card",
        slide5: "Download the Active Zone app",
        slide6: "Open and log in to the Active Zone app",
        slide8: "Scan the QR code at the turnstile reader",


        addressSoon: "Address coming soon",
        medicoverPopUp: "Please provide the phone number that you registered for the Medicover Sport service.",
        myProfile: "My profile",

        //where we are
        mapTitle: "Where are we?",
        mapContent: "Always close to you and in your neighbourhood. No need to waste your time for commuting or looking for a parking lot. Watch us.<strong>  We will soon be present in subsequent locations in Warsaw. Maybe even in your residential estate .</strong>",


        //footer
        cookiesTitle: "This site uses cookies.",
        saveSettings: "Save settings",
        cancelSettings: "Cancel",
        map: "Site Map",
        contact: "Contact with us",
        info: "Information",
        privacy: "Privacy policy",
        terms: "Terms and Conditions",
        cookiesTerms: "Cookies Policy",
        cookiesPrivacy: "Privacy Policy",
        andIn: "and in",
        cookiesAccept: "Accept all",
        cookiesCancel: "Reject",
        cookiesPreferences: "Preferences",
        cookiesText: "We use cookies to ensure smooth and secure website usage, personalize content and ads, provide social media features, and analyze website traffic. Detailed information on how we use cookies can be found in the",
        preferencesText: "We use cookies to help users navigate smoothly and perform specific functions.",
        cookies1: "Necessary cookies contribute to the usability of the site by enabling basic functions such as page navigation and access to secure areas of the website. The website cannot function properly without them.",
        cookie1Title: "Necessary",
        cookies2: "Functional cookies help improve site efficiency and tailor it to your needs and preferences, for example, by remembering any choices made on the site.",
        cookie2Title: "Functional",
        cookies3: "Marketing cookies are used to track individual users across websites to display ads that are relevant and engaging for them.",
        cookie3Title: "Marketing",
        cookies4: "Statistical cookies help website owners understand how different users behave on the site by collecting and reporting anonymous information.",
        cookie4Title: "Statistical"

    },
    pl: {
        welcomeMessage: "Welcome to my website!",
        join: "Zapisz się",
        email: "E-mail:",
        postalCodeFormat_error: "Poprawny  format is 00-000",


        //forms


        male: "mężczyzna",
        female: "kobieta",
        location: "Lokalizacje",
        password_toggle: "pokaż hasło",
        password_toggle_of: "ukryj hasło",
        repeat_email: "Powtórz e-mail:",
        password: "Hasło:",
        multiSport: "Nr karty MultiSport",
        repeat_password: "Powtórz hasło:",
        firstName: "Imię:",
        lastName: "Nazwisko:",
        city: "Miasto:",
        phone: "Numer telefonu:",
        postalCode: "Kod pocztowy:",
        flat: "Nr domu/lok.:",
        sex: "Płeć:",
        street: "Ulica:",
        birthDate: "Data ur.:",
        invoicesToggle: "Czy potrzebujesz fakturę?",
        invoice_postalCode: 'Kod pocztowy:',
        invoice_city: 'Miasto:',
        invoice_name: 'Nazwa:',
        invoice_street: 'Ulica:',
        invoice_flat: 'Nr domu/lok.:',
        invoice_tax: "NIP:",
        send: "Wyślij",
        newPassword: "Nowe hasło:",
        repeatNewPassword: "Powtórz Nowe hasło:",
        provided: "Podany",


        //gallery
        versatile: 'Wszechstronnie',
        modern: 'Nowocześnie',
        intimate: 'Kameralnie',
        active: 'Aktywnie',
        alwaysClose: 'Zawsze blisko',


        //form Errors


        emailError: "Wprowadź poprawny adres E-mail",
        equalTo: "Wprowadzone pola nie są takie same",
        required: "Pole wymagane",
        postalCodeFormat: "Poprawny format to 00-000",
        strongPassword: "Hasło powinno się składać z co najmniej 8 znaków, wielkich i małych liter, cyfr oraz znaków specjalnych.",
        sendError: "Upss... coś poszło nie tak",
        addMembershipSuccess: "Twoja umowa jest już aktywna!",
        monday: 'poniedziałek',
        tuesday: 'wtorek',
        wednesday: 'środa',
        thursday: 'czwartek',
        friday: 'piątek',
        saturday: 'sobota',
        sunday: 'niedziela',
        january: 'Styczeń',
        february: 'Luty',
        march: 'Marzec',
        april: 'Kwiecień',
        may: 'Maj',
        june: 'Czerwiec',
        july: 'Lipiec',
        august: 'Sierpień',
        september: 'Wrzesień',
        october: 'Październik',
        november: 'Listopad',
        december: 'Grudzień',
        minLength: "minimalna długość to 9 liczb",
        maxLength: "maksymalna długość to 9 liczb",
        paymentError: "Płatność nie powiodła sie",
        paymentSuccess: "Płatność powiodła się. Pamiętaj o instalacji aplikacji Active Zone.",
        maxAge: "podany wiek jest zbyt wysoki",
        minAge: "minimalny wiek to 18 lat",


        //club Page
        chooseOffer: "Wybierz ofertę dla siebie!",
        yourChoose: "Twój wybór",
        localizations: 'W jakiej lokalizacji?',
        peakTitle: "O JAKIEJ PORZE?",
        peak: "Bez ograniczeń",
        offPeak: " w godz. od 6.00 do 15.00",
        period: "PRZEZ JAKI OKRES?",
        priceTitle: "Twoja cena to",
        settlementPeriod: "za 28-dniowy okres rozliczeniowy",
        settlementPeriodAfter: "*Obowiązuje 28-dniowy okres rozliczeniowy.",
        settlementPeriodPreSell: "Przez pierwszy miesiąc*",
        settlementPeriodPreSellAfter: "zł pierwszy okres 28 dni, następnie 169zł",
        getMembershipBtn: "Przejdź dalej",
        periodOfNoticeBefore: "z",
        periodOfNoticeAfter: "-dniowym okresem wypowiedzenia",
        // subscriptions: "* na czas nieoznaczony z",
        subscriptionsFor: "subskrypcja na",
        weeks: "tygdni",
        infinityStones: "czas nieokreślony",
        subscriptionsMultiSport: "Subskrypcja MultiSport",
        subscriptionsMedicover: "Subskrypcja Medicover Sport",
        membershipSmart: "Karnet roczny SMART",
        membershipFlex: "Karnet FLEX",
        clubMap: "Mapa dojazdu do klubu",
        classPersons: "liczba osób",
        classSing: "Zapisz się w aplikacji",
        annualContract: "umowa roczna",
        IndefiniteContract: "Bezterminowy",
        hoursInfo: " w godzinach otwarcia klubu",
        forAppHandler: "dla posiadaczy aplikacji",
        inDaClub: "z wejsciem do wybrango klubu ",
        inAllClubs: "do wszystkich klubów",
        withApp: "za pomoca aplikacji",
        withcode: "i kodu QR",

        //profil

        myProfile: "Mój profil",
        invoice: "Faktura",
        personalDate: "Dane osobiste",
        addressDate: "Dane adresowe",
        editBtn: "Edytuj dane",
        changePassword: "Zmień hasło",
        changePasswordSuccess: "Hasło zostało zmienione",
        agree: "Zgody",
        card: "Twoja karta",
        cardBtn: "Zmień kartę",
        hey: "Cześć",
        yourDate: "Twoje dane",
        logOut: "Wyloguj się",


        //profil edit


        profileEditTitle: "Edycja danych",
        saveChanges: "Zapisz zmiany",


        // register
        registerPageBtn: "ZAREJESTRUJ SIĘ",

        //login
        loginBtn: "Zaloguj się",
        LoginTitle: 'Masz konto?',
        passQuestion: "Nie pamiętasz hasła?",
        passBtn: "Zresetuj hasło",
        registerTitle: "Nie masz konta?",
        registerBtn: "Zarejestruj się",
        checkEmail: "Sprawdź skrzynkę e-mail",
        medicoverPopUp: "Podaj numer telefonu, który został przez Ciebie zgłoszony do usługi Medicover Sport.",

        //change pasword
        changePasswordTitle: "Ustaw nowe hasło",
        oldPassword: "Stare hasło:",
        passwordRules: "Nowe hasło powinno się składać z conajmniej 8 znaków, wielkich i małych liter, cyfr oraz znaków specjalnych.",
        changeBtn: "zmień hasło",


        // order
        // map


        // main page slide
        colSlide1: "Jak zostać klientem?",
        colSlide2: "Jak wejść do klubu?",
        slide2: "Wybierz karnet Active Zone lub subskrypcję MultiSport lub Medicover Sport",
        slide1: "Wybierz klub w swojej okolicy",
        slide7: "Wygeneruj kod QR w aplikacji Active Zone lub w aplikacji partnerskiej, jeżeli wybrałeś subskrypcję MultiSport lub Medicover ",
        slide3: "Zarejestruj się",
        slide4: "Dodaj kartę płatniczą",
        slide5: "Zainstaluj aplikację Active Zone",
        slide6: "Otwórz i zaloguj się w aplikacji Active Zone",
        slide8: "Przyłóż kod QR do czytnika umieszczonego na furcie obrotowej",


        // main page
        //hero
        more: 'więcej',
        newClub: "<span class='insideTitle'>Fitness</span><br>za rogiem",

        heroPreTitle: "Wkrótce otwarcie!",
        heroBtn: "KARNET JUŻ OD 119 zł",
        subTitle: "*Tylko w przedsprzedaży.",
        gymsTitle: "Twoja forma, tuż za rogiem",
        ourApp: "Nasza aplikacja w",


        addressSoon: "Adres wkrótce",


        //where we are

        mapTitle: "Gdzie jesteśmy?",
        mapContent: "Zawsze blisko Ciebie i po sąsiedzku. Bez straty czasu na dojazdy lub szukanie miejsca do zaparkowania. Obserwuj nas. <strong>Wkrótce pojawimy się w kolejnych miejscach w Warszawie. Może nawet na Twoim osiedlu.</strong>",


        // order
        orderTitle: "To już ostatni krok!",
        orderPreTitle: "Wybrałeś:",
        orderChangBtn: "Zmień preferencje",
        discountCodeBtn: "Mam kod rabatowy",
        discountCode: "Kod rabatowy:",
        addCode: "Dodaj kod",
        buy: 'ZAPŁAĆ KARTĄ',
        orderBack: "Cofnij",


        //footer
        map: "Mapa strony",
        contact: "Skontaktuj się z nami",
        info: "Informacje",
        privacy: "Polityka prywatności",
        terms: "Regulamin",
        cookiesTerms: "Polityce Cookies",
        cookiesPrivacy: "Polityce Prywatności",
        cookiesAccept: "Akceptuje wszystko",
        cookiesCancel: "Odrzuć",
        saveSettings: "Zapisz ustawienia",
        cancelSettings: "Anuluj",
        cookiesPreferences: "Preferencje",
        andIn: "oraz w",
        cookiesTitle: "Ta strona korzysta z plików cookies.",
        cookiesText: "Wykorzystujemy pliki cookies do zapewnienia sprawnego i bezpiecznego korzystania ze strony internetowej, personalizowania treści i reklam, oferowania funkcji społecznościowych, analizy ruchu na stronie internetowej. Szczegółowe informacje dotyczące tego jak wykorzystujemy pliki cookies znajdziesz w",
        preferencesText: "Używamy plików cookie, aby pomóc użytkownikom w sprawnej nawigacji i wykonywaniu określonych funkcji",
        cookies1: "Niezbędne pliki cookie przyczyniają się do użyteczności strony poprzez umożliwianie podstawowych funkcji takich jak nawigacja na stronie i dostęp do bezpiecznych obszarów strony internetowej. Strona internetowa nie może bez nich poprawnie funkcjonować.",
        cookie1Title: "Niezbędne",
        cookies2: "Funkcjonalne pliki cookie pomagają poprawiać efektywność oraz dostosowywać je do Twoich potrzeb i preferencji np. poprzez zapamiętanie wszelkich wyborów dokonywanych na stronach.",
        cookie2Title: "Funkcjonalne",
        cookies3: "Marketingowe pliki cookie są używane do śledzenia poszczególnych użytkowników na stronach internetowych w celu wyświetlania reklam, które są dla nich istotne i interesujące.",
        cookie3Title: "Marketingowe ",
        cookies4: "Statystyczne pliki cookie pomagają właścicielom stron internetowych zrozumieć, jak różni użytkownicy zachowują się na stronie, zbierając i zgłaszając anonimowe informacje.",
        cookie4Title: "Statystyczne ",


        // map


        //where we are


    },


    uk: {
        myProfile: "Мій профіль",
        welcomeMessage: "Welcome to my website!",
        join: "Запи ши ся",
        email: "E-mail:",
        more: "більше",
//forms
        male: "чоловік",
        female: "Жінка",
        location: "Локації",
        password_toggle: "показати пароль",
        password_toggle_of: "приховати пароль",
        repeat_email: "Повторити E-mail:",
        password: "Пароль:",
        multiSport: "MultiSport",
        repeat_password: "Повторити пароль:",
        firstName: "Ім'я:",
        lastName: "Прізвище:",
        city: "Місто:",
        phone: "Номер телефону:",
        postalCode: "Поштовий код:",
        flat: "No будинку/кв.:",
        sex: "Стать:",
        street: "Вулиця:",
        birthDate: "Дата нар.:",
        invoicesToggle: "Чи потрібна фактура?",
        invoice_postalCode: 'Поштовий код:',
        invoice_city: 'Місто:',
        invoice_name: 'Назва',
        invoice_street: 'Вулиця:',
        invoice_flat: '	No будинку/кв.:',
        invoice_tax: "ІПН",
//gallery
        versatile: 'Всесторонньо',
        modern: 'Сучасно',
        intimate: 'Комфортно',
        active: 'Активно',
        alwaysClose: 'Завжди поруч',
//form Errors
        emailError: "Введіть правильну адресу E-mail",
        equalTo: " Введені поля не є однаковими ",
        required: "Це Поле є обов'язковим",
        postalCodeFormat: "Правильний формат 00-000",
        strongPassword: "Пароль повинен складатися щонайменше з 8 символів, великих і малих букв, цифр та спеціальних знаків.",
        sendError: "Упс... щось пішло не так",
        addMembershipSuccess: "Ваш контракт уже активний!",
        monday: 'понеділок',
        tuesday: 'вівторок',
        wednesday: 'середа',
        thursday: 'четвер',
        friday: "п'ятниця",
        saturday: 'субота',
        sunday: 'неділя',
        january: 'Січень',
        february: 'Лютий',
        march: 'Березень',
        april: 'Квітень',
        may: 'Травень',
        june: 'Червень',
        july: 'Липень',
        august: 'Серпень',
        september: 'Вересень',
        october: 'Жовтень',
        november: 'Листопад',
        december: 'Грудень',
        maxAge: "зазначений вік занадто високий",
        minAge: "мінімальний вік – 18 років",
        minLength: "мінімальна довжина — 9 цифр",
        maxLength: "максимальна довжина — 9 цифр",
        send: "надішли",
        paymentError: "Payment failed",
        paymentSuccess: "Платіж пройшов успішно. Не забудьте встановити додаток Active Zone.",
//club Page
        chooseOffer: "	Вибери пропозицію для себе!",
        yourChoose: "	Твій вибір",
        localizations: 'У якій локації?',
        peakTitle: " В ЯКИЙ ЧАС?",
        peak: "Без обмежень",
        offPeak: " З 6.00 до 15.00",
        period: "ПРОТЯГОМ ЯКОГО ЧАСУ?",
        priceTitle: "Твоя ціна це",
        settlementPeriod: "за 28-денний розрахунковий період",
        settlementPeriodAffter: "*Діє 28-денний розрахунковий період.",
        settlementPeriodPreSell: "Протягом першого місяця*",
        settlementPeriodPreSellAfter: " PLN  за перший період 28 днів, потім 169	PLN ",
        getMembershipBtn: "Перейти далі",
        periodOfNoticeBefore: "*з",
        periodOfNoticeAfter: "- місячним періодом повідомлення",
        subscriptions: "* на невизначений час з",
        subscriptions12weeks: "*абонемент на 12 тижнів",
        membershipSmart: "Річний абонемент SMART",
        membershipFlex: "Абонемент FLEX",
        subscriptionsMultiSport: "Абонемент MultiSport",
        subscriptionsMedicover: "Абонемент Medicover Sport",
        settlementPeriodAfter: "*Діє 28-денний розрахунковий період.",
        clubMap: "Мапа проїзду до клубу",


        //profil
        invoice: "Персональні дані",
        personalDate: "Адресні дані",
        addressDate: "Рахунок-фактура",
        editBtn: "Редагувати дані",
        changePassword: "Змінити пароль",
        changePasswordSuccess: "Пароль було змінено",
        agree: "Згоди",
        card: "Твоя картка",
        cardBtn: "	Змінити картку",
        hey: "Привіт",
        yourDate: "Твої дані",
        //profil edit
        profileEditTitle: "Редагування даних",
        saveChanges: "Зберегти зміни",
        // register
        registerPageBtn: "Зареєструватися",
        //login
        loginBtn: "Увійти",
        LoginTitle: 'Маєш обліковий запис?',
        passQuestion: "Не пам'ятаєш пароля?",
        passBtn: "Скинути пароль",
        registerTitle: "Немає облікового запису?",
        registerBtn: "Зареєструватися",
        logOut: "вийти",

        // order
        // map
        // mainpageslide
        colSlide1: "Як стати клієнтом?",
        colSlide2: "Як увійти до клубу?",
        slide2: "Вибери абонемент - Active Zone, MultiSport або Medicover Sport",
        slide1: "Вибери клуб у своїй місцевості",
        slide4: "Додай платіжну картку",
        slide3: "Зареєструйся",
        slide5: "Встанови застосунок Active Zone",
        slide6: "Відкрий і увійди у застосунок Active Zone",
        slide7: "Згенеруй QR-код у застосунку Active Zone або в партнерському застосунку, якщо ти вибрав/-ла абонемент MultiSport або Medicover Sport",
        slide8: "Скануй QR-код на турнікеті",
        // mainpage
        //hero
        // newClub: "<span class='strong'>Fitness</span><br>za rogiem",

        newClub: "<span class='insideTitle'>Фітнес</span><br>за рогом",
        heroPreTitle: "Скоро відкриття!",
        heroBtn: "АБОНЕМЕНТ ВІД 119 PLN",
        subTitle: "*Тільки в передпродажу.",
        gymsTitle: "Твоя форма на відстані витягнутої руки",
        ourApp: "Наш застосунок знайдеш у",
        checkEmail: "Перевірте свою електронну пошту",
        medicoverPopUp: "Вкажіть номер телефону, який ви зареєстрували для послуги Medicover Sport.",

        addressSoon: "Адреса незабаром",
//where we are
        mapTitle: "Де ми є?",
        mapContent: "Завжди поруч і по сусідству. Без втрат часу на дорогу або пошук місця для паркування. Слідкуй за нами.<strong>Незабаром з'явимося в нових місцях уВаршаві. Можливо, навіть у твоєму районі.	</strong>",
        orderTitle: "	Це вже останній крок!",
        orderPreTitle: "Ти вибрав/-ла:",
        orderChangBtn: "Змінити вподобання",
        discountCodeBtn: "Маю код знижки",
        discountCode: "Код знижки:",
        addCode: "Додати код",
        buy: "СПЛАТИТИ КАРТКОЮ",
        weeks: "тижні",
        orderBack: "Повернутися",
        inDaClub: "з входом до обраного клубу",
        infinityStones: "безстроковий період",
        subscriptionsFor: "абонемент на",
        forAppHandler: "для користувачів додатка",
        changePasswordTitle: "Встановіть новий пароль",
        passwordRules: "Новий пароль повинен містити щонайменше 8 символів, включаючи великі та малі літери, цифри та спеціальні символи.",
        newPassword: "Новий пароль:",
        repeatNewPassword: "Повторіть новий пароль:",
        oldPassword: "Старий пароль",
        changeBtn: "Змінити пароль",
        withApp: "за допомогою додатка",
        withcode: "та QR-кодом",
        inAllClubs: "до всіх клубів",


        //footer
        saveSettings: "Зберегти налаштування",
        cancelSettings: "Скасувати",
        cookiesTitle: "Цей сайт використовує файли cookie.",
        map: "Мапа сайту",
        contact: "Зв'яжіться з нами",
        info: "Інформація",
        privacy: "Політика конфіденційності",
        terms: "Правила та умови",
        cookiesTerms: "Політика щодо файлів cookie",
        cookiesPrivacy: "Політика конфіденційності",
        andIn: "та в",
        cookiesAccept: "Прийняти все",
        cookiesCancel: "Відхилити",
        cookiesPreferences: "Налаштування",
        cookiesText: "Ми використовуємо файли cookie для забезпечення безпечного та ефективного користування вебсайтом, персоналізації контенту та реклами, надання функцій соціальних мереж і аналізу трафіку на вебсайті. Детальну інформацію про те, як ми використовуємо файли cookie, можна знайти в",
        cookies1: "Необхідні файли cookie сприяють зручності використання сайту, дозволяючи виконувати базові функції, такі як навігація сторінкою та доступ до безпечних зон вебсайту. Сайт не може функціонувати належним чином без них.",
        cookie1Title: "Необхідні",
        cookies2: "Функціональні файли cookie допомагають покращити ефективність сайту та адаптувати його до ваших потреб і уподобань, наприклад, запам’ятовуючи будь-які вибори, зроблені на сайті.",
        cookie2Title: "Функціональні",
        cookies3: "Маркетингові файли cookie використовуються для відстеження окремих користувачів на вебсайтах, щоб показувати рекламу, яка є актуальною та цікавою для них.",
        cookie3Title: "Маркетингові",
        cookies4: "Статистичні файли cookie допомагають власникам вебсайтів зрозуміти, як різні користувачі поводяться на сайті, збираючи та повідомляючи анонімну інформацію.",
        cookie4Title: "Статистичні",

    }
};


document.querySelectorAll('[data-translation-key]').forEach(el => {
    const key = el.getAttribute('data-translation-key');
    if (key) {
        el.innerHTML = translations[lang][key];
    }
});


